var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 133,
    viewBox: "0 0 150 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 17C107.032 17 133 42.9673 133 74.9994C133 107.033 107.032 133 75 133C42.9676 133 17 107.033 17 74.9994C17 42.9673 42.9676 17 75 17Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 79C76 77.896 76.896 77 78 77L111.001 77C112.105 77 113.001 77.896 113.001 79C113.001 80.104 112.105 81 111.001 81L78 81C76.896 81 76 80.104 76 79",
    fill: "#B2B5B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93 113C93 111.896 93.896 111 95 111L128.001 111C129.105 111 130.001 111.896 130.001 113C130.001 114.104 129.105 115 128.001 115L95 115C93.896 115 93 114.104 93 113",
    fill: "#B2B5B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 43C95 41.896 95.896 41 97 41L130.001 41C131.105 41 132.001 41.896 132.001 43C132.001 44.104 131.105 45 130.001 45L97 45C95.896 45 95 44.104 95 43",
    fill: "#B2B5B2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 66,
    width: 69,
    height: 26,
    rx: 6,
    stroke: "#B2B5B2",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 100,
    width: 69,
    height: 26,
    rx: 6,
    stroke: "#B2B5B2",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 30,
    width: 69,
    height: 26,
    rx: 6,
    stroke: "#B2B5B2",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5714 15C20.1278 15 19.7188 15.1721 19.4302 15.4527C19.1444 15.7305 19 16.0891 19 16.4444V46.2642L30.2888 38.4248C31.3177 37.7103 32.6823 37.7103 33.7112 38.4248L45 46.2642V16.4444C45 16.0891 44.8556 15.7306 44.5698 15.4527C44.2812 15.1721 43.8722 15 43.4286 15H20.5714ZM15.2477 11.1508C16.6737 9.76438 18.5902 9 20.5714 9H43.4286C45.4098 9 47.3263 9.76438 48.7523 11.1508C50.1812 12.5399 51 14.4423 51 16.4444V52C51 53.1166 50.3798 54.1408 49.3904 54.6583C48.401 55.1759 47.206 55.101 46.2888 54.4641L32 44.5413L17.7112 54.4641C16.794 55.101 15.599 55.1759 14.6096 54.6583C13.6202 54.1408 13 53.1166 13 52V16.4444C13 14.4423 13.8188 12.5399 15.2477 11.1508Z",
    fill: "#008C73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLibrary);
export default __webpack_public_path__ + "static/media/empty-library.d9af7162a7db85215d761acaa5dc3794.svg";
export { ForwardRef as ReactComponent };